let authModulePromise = null

export function getFirebaseAuthModule() {
  if (!authModulePromise) {
    authModulePromise = Promise.all([
      import('@/firebase'),
      import('firebase/auth'),
    ]).then(([{ auth }, authFns]) => ({ auth, ...authFns }))
  }
  return authModulePromise
}
